import { catalystApi } from './http';

export async function getQlikToken(customerId, email, password, token) {
  catalystApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const params = { params: { customerId, email, password } };

  const response = await catalystApi.get('/SSO/register', params);

  return response.data;
}
